// This file was once generated when you created this area
// but you can edit it freely
import { transformRoutes } from '@backoffice-frontend/common'

const BaseWelcomeAreaRoutes = {
  route: '/welcome',
}

export const WelcomeAreaRoutes = transformRoutes(BaseWelcomeAreaRoutes)
export const WelcomeAdminPanelAreaRoutes = transformRoutes(
  BaseWelcomeAreaRoutes,
)
